export const formatValueFromMapping = (value, field, mapping) => {
    if ( field in mapping ) {
        return mapping[field][value]
    }
    return value
};

export function getInitialSortField(immutableBaseData) {
    const fields = immutableBaseData.fields;
    // because we only want the name, but need to accommodate no fields, we manually assign undefined
    return fields.length > 0 ? fields[0].name : undefined;
}

export function checkActiveFilterMembership(activeFilters, field, option) {
    let filterIsActive = false;

    activeFilters.forEach(item => {
        if ( item.field === field && item.value === option ) {
            filterIsActive = true
        }
    });

    return filterIsActive;
}

export function generateTempRowKey() {
    const choices = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    const keySize = 16;  // should be long enough to reasonably avoid key collisions
    return [...Array(keySize)].reduce(tempRowKey => tempRowKey + choices[~~(Math.random()*choices.length)], '');
}

export function createNewRegisterTableRow(fields, fieldTypes, defaults) {
    const newRow = {};
    fields.forEach(field => {
        newRow[field.name] = defaults[field.name]
    });

    return newRow
}

export function tableColWidth(fieldWidth) {

    // Create a fake element in the dom to emulate what a column would do in a table cell to get
    // width based on the longest string in the column.
    let span = document.createElement('span');
    span.innerText = 'A'.repeat(fieldWidth);
    span.style.fontSize = 13 + "px";
    span.style.padding = 12 + "px";
    document.body.appendChild(span);
    let width = span.offsetWidth;
    document.body.removeChild(span);

    // This is certainly not an exact science - but here goes:
    // If it's less than 200px wide then we're adding 60 pixels to avoid column header wrapping due to
    // icon in column header. More than 200 then it's unlikely column header is the longest string.
    // Column headers more than 200px....too bad i say - you may wrap.
    // If it's more than 400px then it's just too damn long. Let's be slightly sensible.
    if (width < 200) {
        return width + 60;
    } else if (width > 400) {
        return 400;
    }

    return width;
}

export function getRawValue(value) {

    value = value.replace('px', '');
    return parseInt(value.replace('%', ''), 10);

}